import { z } from 'zod'

const PHONE_REGEX = /^(0|\+84)(3[2-9]|5[25689]|7[06-9]|8[1-9]|9[0-9])\d{7}$/

export const loginSchema = z.object({
  identifier: z.string().trim().min(1, 'Vui lòng nhập email hoặc SĐT'),
  password:   z.string().min(6, 'Mật khẩu tối thiểu 6 ký tự'),
  remember:   z.boolean().optional(),
})
export type LoginValues = z.infer<typeof loginSchema>

export const registerSchema = z.object({
  fullName: z.string().trim().min(2, 'Họ tên tối thiểu 2 ký tự').max(80),
  phone:    z.string().trim().regex(PHONE_REGEX, 'Số điện thoại không hợp lệ'),
  email:    z.string().trim().email('Email không hợp lệ'),
  password: z.string().min(6, 'Mật khẩu tối thiểu 6 ký tự'),
  confirm:  z.string().min(6, 'Vui lòng nhập lại mật khẩu'),
  agree:    z.literal(true, { errorMap: () => ({ message: 'Bạn cần đồng ý điều khoản' }) }),
}).refine((d) => d.password === d.confirm, {
  path: ['confirm'],
  message: 'Mật khẩu nhập lại không khớp',
})
export type RegisterValues = z.infer<typeof registerSchema>
